<!------------- ETC comments threads pops up ------------------>
	<div class="reject_popup" *ngIf="thread_msg !== null">
		<div class="reject_popup_wrapper">
			<div class="reject_popup_header">
				<h3>{{"RejectReason" | translate}}</h3><button class="pop_close" (click)="threadClose()"><i class="bi bi-x"></i></button>
			</div>
			<div class="reject_popup_body" *ngIf="thread_msg.length > 0; else noMsg">
				<ul>
					<li *ngFor="let msg of thread_msg" class="client asso">
						<h5>{{msg.modifyUserName}}<span>{{formatDateTime(msg.modifyDate)}}</span></h5>
						<p>{{msg.modifyComment}}</p>
					</li>
				</ul>
			</div>
			<ng-template #noMsg>
				<div class="reject_popup_body">
					<p>{{'NoComments' | translate}}</p>
				</div>

			</ng-template>
		
		</div>
		
	</div>

<!---------------------------- END ----------------------------->


<!--  ############### Top Select Month Start ################# -->
<div class="select_month_section">
	<section class="row">
		<div class="select_month col-auto">
			<h2><label for="select_year_month">{{"SELECTMONTH" | translate}}</label> </h2>
			<select 
			class="form-select" 
			aria-label="Month selection"
			[(ngModel)]="selectedTimesheetId"
			(change)="fncCng($event)">
				<option *ngFor="let date of monthDropdown" [value]="date.timesheetId">
					{{ "DDMONTH."+getMonth(date.weekEnding) | translate}} {{getYear(date.weekEnding)}} ({{date.companyName}})
				</option>
			</select>
		</div>
		<div class="col-auto co_name">
			<h2>{{"CompanyName" | translate}}:</h2>
			<p>{{timeSheetCmnData?.customerName}}</p>
		</div><!-- {{userCode}} -->
		<div class="summary col-auto">
			<h2>{{"MonthlySummary" | translate}} :</h2>
			<ul>
				<li>
					<p><strong>{{"REGULAR" | translate}} - </strong> <span>{{timeSheetTopPannel?.regular}}</span></p>
				</li>
				<li>
					<p><strong>{{"OVERTIME" | translate}} - </strong> <span>{{timeSheetTopPannel?.overtime}}</span></p>
				</li>
				<li>
					<p><strong>{{"MIDNIGHT" | translate}} - </strong> <span>{{timeSheetTopPannel?.midnightOvertime}}</span></p>
				</li>
				<li>
					<p><strong>{{"TOTAL" | translate}} - </strong> <span>{{timeSheetTopPannel?.total}}</span></p>
				</li>
			</ul>
		</div>
		</section>
</div>

<!--  ############### Top Select Month End ################# -->
<!--  ############### Middle Containt Area Start ################# -->
<div class="container_wrapper">

	<div class="actio_button_area">
		<div class="asso_name">
			<strong>{{'Associate' | translate}} : </strong>{{timeSheetTopPannel?.userName}}
		</div>
		<button class="butn save_entry btn" (click)="onSave()" [disabled]="archive">{{"SAVE" | translate}}</button>
		<!--<button class="butn cancel_entry btn">{{"CANCEL" | translate}}</button>-->
		<!-- <button class="butn log_entry btn">{{"LOG" | translate}}</button> -->
		 <a class="butn go_back btn" href="manager-timesheet/{{timesheetIdOrg}}/{{userIdOrg}}">{{"Back" | translate}}</a>
		 <a class="butn pdf_down btn" href="javascript:void(0)" (click)="dwnPdf(timesheetId)">{{"PDFDWN" | translate}}</a>
	</div>
	<div  *ngIf="dashboard_msg !== null" class="alert alert-{{msgType}} alert-dismissible" (click)="reset()" role="alert">
		{{ dashboard_msg | translate}}
			
		<button type="button" class="close" data-dismiss="alert" aria-label="Close" style="float: right; border-radius: 15px; border: none;">
		<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div *ngIf="dashboard_err_msg?.length"
		class="alert alert-danger alert-dismissible timesheet-err"
		role="alert">

		<p *ngFor="let err of dashboard_err_msg" class="err-msg">
			<strong 
			(click)="scrollToRow(err.row)">{{ err.disDate }}:</strong> {{ "TimeSheetError."+err.message | translate}}
		</p>

		<button type="button"
				class="close"
				(click)="reset()"
				aria-label="Close">
			<!-- <span aria-hidden="true">&times;</span> -->
		</button>
	</div>
	<div class="time_sheet_ligend" *ngIf="lang === 'en'">
		<ul>
			<li class="status"><span>{{"STATUS" | translate}}</span></li>
			<li class="nSubmit"><s>{{"Status.N" | translate}}</s><span>{{"Status.NOTSUBMIT" | translate}}</span></li>
			<li class="submit"><s>{{"Status.S" | translate}}</s><span>{{"Status.SUBMIT" | translate}}</span></li>
			<!--<li class="fix"><s>F</s><span>Fix</span></li>-->
			<li class="approve"><s>{{"Status.A" | translate}}</s><span>{{"Status.APPROVE" | translate}}</span></li>
			<li class="reject"><s>{{"Status.R" | translate}}</s><span>{{"Status.REJECT" | translate}}</span></li>
		</ul>
	</div>
	<!--  ############### Data Table Start ################# -->
	<div class="time_sheet_table_wrapper">
		<!-- Table Heading Start -->
		<div class="timeSheet_row_heading timesheet-header">
            <section>
                <article>
                    <div class="tbl_date">{{"DATE" | translate}}</div>
                    <div class="tbl_approve">
                        <label class="switch">
							<input type="checkbox"
							[(ngModel)]="selectAll"
								[ngModelOptions]="{standalone: true}"
								(change)="toggleAllApprovals($event)"
								 [disabled]="archive">
							<span class="slider"></span>
						</label>
                        {{"SUBMIT" | translate}}
                    </div>
                    <div class="tbl_status">{{"STATUS" | translate}}</div>
                    <div class="tbl_action">{{"EDIT" | translate}}</div>                
                    <div class="tbl_start">{{"START" | translate}}</div>
                    <div class="tbl_finish">{{"FINISH" | translate}}</div>
                    <div class="tbl_break">{{"BREAK" | translate}}</div>
                    <div class="tbl_mnBreak">{{"MIDNIGHTBREAK" | translate}}</div>
                    <div class="tbl_note">{{"NOTE" | translate}}</div>
                    <div class="tbl_home">{{"HOME" | translate}}</div>
                    <div class="tbl_exp">{{"EXPENSES" | translate}}</div>
                    <div class="tbl_amtExp">{{"AMOUNTOFEXPENSES" | translate}}</div>
                    <div class="tbl_etc">{{"ETC" | translate}}</div>
                </article>
            </section>
        </div>
		<!-- Table Heading End -->
		<!-- Table Data Start as loop-->
		 <div class="timeSheet_row {{getClass(item.status)}}" *ngFor="let item of timeSheetData; let i = index" id="timeSheet_row_{{i}}">
            <section>
                <aside>
                    <div class="tbl_nav"><button class="expand" [class.active]="expandedRowsButton[i]" (click)="toggleBelowRows(i)"></button></div>
					<div class="tbl_date">
						<strong class="{{getDayWeekKey(item.dayDate).shortweekday}} {{item.isHoliday? 'sun':''}}">{{ getDayWeekKey(item.dayDate).day }} {{ getDayWeekKey(item.dayDate).weekdayKey | translate }}</strong>
					</div>
					<div class="tbl_status">
						<dl><span [ngClass]="{ 'get_comment': (item.status === 30 || item.status === 20) }" (click)="onRejectClick(item)">{{ getStatus(item.status).statusKey | translate }}</span></dl>
					</div>
					<div class="tbl_start">
						<p *ngIf="(item.status == 30 || item.status == 40) && editingRow !== i">{{item.startTime}}</p>
					</div>
					<div class="tbl_finish">
						<p *ngIf="(item.status == 30 || item.status == 40) && editingRow !== i">{{item.endTime}}</p>
					</div>
					<div class="tbl_break">
						<p *ngIf="(item.status == 30 || item.status == 40) && editingRow !== i">{{item.breakMinutes}}</p>
					</div>
					<div class="tbl_mnBreak">
						<p *ngIf="(item.status == 30 || item.status == 40) && editingRow !== i">{{item.midnightBreakMinutes}}</p>
					</div>
                </aside>
                <article [ngClass]="{ 'expanded': expandedRows[i] }">
					<div class="tbl_date">
						<strong class="{{getDayWeekKey(item.dayDate).shortweekday}} {{item.isHoliday? 'sun':''}}">{{ getDayWeekKey(item.dayDate).day }} {{ getDayWeekKey(item.dayDate).weekdayKey | translate }}</strong>
					</div>
                    <div class="tbl_approve">
						<samp></samp>
                        <label class="switch" *ngIf="item.status == 10">
							<input type="checkbox" 
							[(ngModel)]="item.markedForSubmit" 
							[ngModelOptions]="{standalone: true}" 
							class="chkStatus" (change)="chkSubmitCnt()" 
							[disabled]="archive" />
							<span class="slider"></span>
						</label>
                    </div>
                    <div class="tbl_status">
						<samp>{{"STATUS" | translate}}</samp>
						<dl><span [ngClass]="{ 'get_comment': (item.status === 30 || item.status === 20) }" (click)="onRejectClick(item)">{{ getStatus(item.status).statusKey | translate }}</span></dl>
					</div>
                    <div class="tbl_action">
						<samp>{{"EDIT" | translate}}</samp>
                        <div class="reject_save">
                            <button name="Edit" class="edit" (click)="editReject(i)" *ngIf="item.status == 30 && editingRow !== i" [disabled]="archive">edit</button>
							<button name="cancel" class="cancel" (click)="cancelReject(i)" *ngIf="editingRow === i">cancel</button>
							<button name="save" class="save" (click)="saveReject(i)" *ngIf="editingRow === i">save</button>
						</div>    
                    </div>
                    <div class="tbl_start">
                        <samp>{{"START" | translate}}</samp>
						<select 
						class="form-select start_hour"
						id="start_hour_{{i}}"
						[(ngModel)]="item.startHour"
						*ngIf="item.status == 10 || item.status == 20 ||editingRow === i">
							<option *ngFor="let hour of hourDropDown" value="{{hour}}">{{hour}}</option>
						</select>
						<b *ngIf="item.status == 10 || item.status == 20 ||editingRow === i">:</b>
						<select 
						class="form-select start_minute"
						id="start_minute_{{i}}"
						[(ngModel)]="item.startMinute"
						*ngIf="item.status == 10 || item.status == 20 ||editingRow === i">
							<option *ngFor="let min of minuteDropDown" value="{{min}}">{{min}}</option>
						</select>
						<!-- <p-datepicker 
						id="startTime_{{i}}"
						class="form-control start_time"
						inputId="calendar-timeonly" 
						[(ngModel)]="item.startTime" 
						[timeOnly]="true"
						[ngModelOptions]="{standalone: true}" 
						*ngIf="item.status == 10 || item.status == 20 || editingRow === i" (click)="selectStartTime(i)" /> -->
                        <!-- <input type="text"
							class="form-control start_time"
							[(ngModel)]="item.startTime"
							[ngModelOptions]="{standalone: true}" 
							
							*ngIf="item.status == 10 || item.status == 20 || editingRow === i" /> -->

						<!-- <input type="text" name="startTime" id="startTime" class="form-control start_time" value="{{getStartTime(item.startTime)}}" *ngIf="item.status == 10 ||item.status == 20" /> -->
						<p *ngIf="(item.status == 30 || item.status == 40) && editingRow !== i">{{item.startTime}}</p>
                    </div>
                    <div class="tbl_finish">
                        <samp>{{"FINISH" | translate}}</samp>
						<!-- <p-datepicker
						id="endTime_{{i}}"
						class="form-control finish_time"
						inputId="calendar-timeonly" 
						[timeOnly]="true"
						[(ngModel)]="item.endTime"
						[ngModelOptions]="{standalone: true}" 
						*ngIf="item.status == 10 || item.status == 20 ||editingRow === i" (click) = selectFinishTime(i) /> -->
						<select 
						class="form-select end_hour"
						id="finish_hour_{{i}}"
						[(ngModel)]="item.endHour"
						*ngIf="item.status == 10 || item.status == 20 ||editingRow === i">
							<option *ngFor="let hour of endHourDropDown" value="{{hour}}">{{hour}}</option>
						</select>
						<b *ngIf="item.status == 10 || item.status == 20 ||editingRow === i">:</b>
						<select 
						class="form-select end_minute"
						id="finish_minute_{{i}}"
						[(ngModel)]="item.endMinute"
						*ngIf="item.status == 10 || item.status == 20 ||editingRow === i">
							<option *ngFor="let min of minuteDropDown" value="{{min}}">{{min}}</option>
						</select>
                        <!-- <input type="text"
							class="form-control finish_time"
							[(ngModel)]="item.endTime"
							[ngModelOptions]="{standalone: true}" 
							*ngIf="item.status == 10 || item.status == 20 ||editingRow === i" /> -->
						<!-- <input type="text" name="finish_time" id="finish_time" class="form-control finish_time" value="{{getEndTime(item.endTime)}}" *ngIf="item.status == 10 ||item.status == 20" /> -->

						<p *ngIf="(item.status == 30 || item.status == 40) && editingRow !== i">{{item.endTime}}</p>
                    </div>
                    <div class="tbl_break">
                        <samp>{{"BREAK" | translate}}</samp>
                        <input type="text" name="break_time" id="break_time_{{i}}" class="form-control break_time" 
						inputmode="numeric" 
						oninput="this.value = this.value.replace(/[^0-9]/g, '')" 
						style="ime-mode: inactive;"
						[(ngModel)]="item.breakMinutes" 						
						*ngIf="item.status == 10 ||item.status == 20 || editingRow === i" />
						<!-- <p *ngIf="isBreakMinutesInvalid(item) && (item.status == 10 || item.status == 20 || editingRow === i)" style="color:red; font-size:12px;">
    Please enter a valid number
  </p> oninput="if (/[^0-9]/.test(this.value)) this.value = '0';" -->
						<p *ngIf="(item.status == 30 || item.status == 40) && editingRow !== i">{{item.breakMinutes}}</p>
                    </div>
                    <div class="tbl_mnBreak">
                        <samp>{{"MIDNIGHTBREAK" | translate}}</samp>
                        <input type="text" name="mid_night_break" id="mid_night_break_{{i}}"
							class="form-control mid_night_break" 
							inputmode="numeric" 
							oninput="this.value = this.value.replace(/[^0-9]/g, '')" 
							style="ime-mode: inactive;"
							[(ngModel)]="item.midnightBreakMinutes" 
							*ngIf="item.status == 10 ||item.status == 20 || editingRow === i" />
							<p *ngIf="(item.status == 30 || item.status == 40) && editingRow !== i">{{item.midnightBreakMinutes}}</p>
                    </div>
                    <div class="tbl_note">
                        <samp>{{"NOTE" | translate}}</samp>
                        <select class="form-select note" name="note" id="note_{{i}}" *ngIf="item.status == 10 ||item.status == 20 || editingRow === i" [(ngModel)]="item.noteId" (change)="chkNote($event, i)">
						<!-- <option value="" selected="">{{"NOTEDD.SELECT" | translate}}...</option> -->
						<option *ngFor="let note of noteTypes" [value]="note.typeID">
							<!-- {{ note.itemName }} -->
							  {{getNote(note.typeID).noteKey | translate}}
						</option>
						</select>
						<p *ngIf="(item.status == 30 || item.status == 40) && editingRow !== i">{{getNote(item.noteId).noteKey | translate}}</p>
                    </div>
                    <div class="tbl_home">
                        <samp>{{"HOME" | translate}}</samp>
                        <label class="switch2">
							<input type="checkbox" [(ngModel)]="item.whf" [ngModelOptions]="{standalone: true}" [disabled]="(item.status == 30 || item.status == 40) && editingRow !== i">
							<span class="slider"></span>
						</label>
                    </div>
                    <div class="tbl_exp">
                        <samp>{{"EXPENSES" | translate}}</samp>
                        <select class="form-select expenses" id="expenses_{{i}}" name="expenses" *ngIf="item.status == 10 ||item.status == 20 || editingRow === i" [(ngModel)]="item.expenseId">
							<!-- <option value="">{{"ExpenseDD.SELECT" | translate}}...</option> -->
							<option *ngFor="let expenses of expensesTypes"  [value]="expenses.typeID">
								<!-- {{ expenses.itemName }} -->
								  {{getExpenses(expenses.typeID).expensesKey | translate}}
							</option>
						</select>
						<p *ngIf="(item.status == 30 || item.status == 40) && editingRow !== i">{{getExpenses(item.expenseId).expensesKey | translate}}</p>
                    </div>
                    <div class="tbl_amtExp">
                        <samp>{{"AMOUNTOFEXPENSES" | translate}}</samp>
                        <input type="text" name="cost" id="cost_{{i}}" class="form-control cost" inputmode="numeric" 
						oninput="this.value = this.value.replace(/[^0-9]/g, '')" 
						style="ime-mode: inactive;" 
						[(ngModel)]="item.cost" 
						*ngIf="item.status == 10 ||item.status == 20 || editingRow === i" />
						<p *ngIf="(item.status == 30 || item.status == 40) && editingRow !== i">{{item.cost}}</p>
                    </div>
                    <div class="tbl_etc">
                        <samp>{{"ETC" | translate}}</samp>
						
						<p *ngIf="editingRow !== i" 
						class="info" 
						data-bs-toggle="tooltip" 
						data-bs-placement="top" 
						[attr.title]="item.etcRemarks || 'No remark'"
  						#tooltipEl>{{getShortText(item.etcRemarks, 25)}}</p>
                    </div>
					<address *ngIf="editingRow === i" >
						<samp>{{"ETC" | translate}}</samp>
						<input type="text" name="etc" id="etc" class="form-control" [(ngModel)]="item.etcRemarks" />
					</address>
                </article>
            </section>
        </div>
		<!-- Table Heading End as loop -->
	</div>
	
	<!--  ############### Data Table End ################# -->
	<div class="work_hour_info">
		<h6>{{"Contract" | translate}} -</h6>
		<span *ngIf="jobOrderData">{{"START" | translate}} {{ toTimeString(jobOrderData.WorkStartTime) }}</span><span *ngIf="jobOrderData">{{"FINISH" | translate}} {{ toTimeString(jobOrderData.WorkEndTime) }}</span><span *ngIf="jobOrderData">{{"BREAK" | translate}} {{jobOrderData.breakTime}}</span><span *ngIf="jobOrderData">{{"MIDNIGHTBREAK" | translate}} {{jobOrderData.midBreakTime}}</span>
	</div>
	<div class="time_sheet_comment">
		<h3>{{"CommentsRemarks" | translate}}</h3>
		<textarea *ngIf="timeSheetCmnData" class="form-control" id="floatingTextarea2" [(ngModel)]="timeSheetCmnData.comments"
			style="height: 100px"></textarea>
	</div>
	<div class="actio_button_area">
		<button class="butn save_entry btn" (click)="onSave()" [disabled]="archive">{{"SAVE" | translate}}</button>
		<!--<button class="butn cancel_entry btn">{{"CANCEL" | translate}}</button>-->
		<!-- <button class="butn log_entry btn">{{"LOG" | translate}}</button> -->
		 <!-- <a class="butn log_entry btn" href="associate-time-log/{{timesheetIdOrg}}">{{"LOG" | translate}}</a> -->
	</div>
	<!--  ############### Row 1 End ################# -->
	<div class="training_entry_box">
		<h4>{{"EducationTrainingRecords" | translate}}</h4>
		<p>{{trainingCommentsDis}} &nbsp;<a href="javascript: void(0)"  data-bs-toggle="modal" data-bs-target="#training_history_popup" >{{"EducationTrainingRecords" | translate}}</a>
		</p>
	</div>
</div>

<!-- Modal for training_history Start-->
	<div class="modal fade" id="training_history_popup" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
		aria-labelledby="staticBackdropLabel" aria-hidden="true">
		<div class="modal-dialog modal-lg modal-dialog-scrollable custom_modal">
			<div class="modal-content">
				<div class="modal-header">
					<h3 class="modal-title">{{"ClienttimeSheet.TrainingHistory" | translate}}</h3>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="sub_header_block">
					<div class="col-auto">
						{{"TrainingHistoryHeading" | translate}}
					</div>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-12">
							<textarea name="" id="" class="form-control" rows="3" placeholder="{{'TrainingCmntPlaceHolder' | translate}}" [(ngModel)]="trainingComments" ></textarea>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button #btntraining_history_popup type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="btntraining_history_popup">{{"CLOSEBTN" | translate}}</button>
					<button type="button" class="btn btn-primary" (click)="saveTraining()">{{"SAVE" | translate}}</button>
				</div>
			</div>
		</div>
	</div>
	<!-- Modal for training_history End-->
<!--  ############### Middle Containt Area End ################# -->